<div 
  class="container mt-5 mb-5"
  style="height: 85dvh;">
  <div class="row justify-content-center h-100 align-items-center">

    <div class="col-12 text-center mb-4">
      <h2>
        Encuesta completada
      </h2>
      <p>
        ¡Gracias por completar la encuesta!
      </p>
      <p>
        La encuesta ya ha sido finalizada. Agradecemos tu valioso
        tiempo que se tomó para brindarnos sus comentarios y seguir
        mejorando para ti.
      </p>
    </div>

  </div>
</div>